import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, LinearProgress } from '@mui/material'
import { BaseFeedbackConIcona, useRichiestaServer } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { useAppContext } from 'GlobalContext'

export default function AvvioSPID() {
  const { idpurl } = useParams()

  const [messaggio, setMessaggio] = useState()

  const { uri } = useAppContext()

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServer()

  useEffect(() => {
    async function avviaSPID() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.SPID_AVVIO, null, {}, {
        params: { idpurl: decodeURIComponent(idpurl) },
        headers: { uri, backUrlOrigin: window.location.origin },
      })

      if (ok) {
        const { esito, sso_request, messaggio } = data
        if (esito) {
          window.location.href = sso_request
        }
        if (messaggio) {
          setMessaggio(messaggio)
        }
      }
    }
    avviaSPID()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idpurl])

  return (
    <Box sx={{ p: 4 }}>
      {ScatolaMessaggi}

      {messaggio && <BaseFeedbackConIcona.Errore messaggio={messaggio} />}

      {inAttesaDelServer && <LinearProgress />}
    </Box>
  )
}